export default function getData() {
  return {
    legend: {},
    tooltip: {

    },
    dataset: {
      // Provide data.
      source: [
        ['Product', '线索', '初审通过', '完成项目考察评分', '分管领导审批通过', '主管领导审批通过', '上会/审签通过', '签约'],
      ]
    },
    grid: {
      left: "8px",
      right: "8px",
      bottom: "0",
      top: "110px",
      containLabel: true,
    },
    xAxis: { type: 'category' },
    yAxis: {

    },
    series: [
      { type: 'bar', color: "#33b2df", label: { show: true, position: "top", color: "#0168c1", formatter: function (a, b, c) { return  a.value[1] } } },
      { type: 'bar', color: "#546E7A", label: { show: true, position: "top", color: "#0168c1", formatter: function (a, b, c) { return  a.value[2] } }},
      { type: 'bar', color: "#7569b3", label: { show: true, position: "top", color: "#0168c1", formatter: function (a, b, c) { return  a.value[3] } } },
      { type: 'bar', color: "#d4526e", label: { show: true, position: "top", color: "#0168c1", formatter: function (a, b, c) { return  a.value[4] } } },
      { type: 'bar', color: "#13d8aa", label: { show: true, position: "top", color: "#0168c1", formatter: function (a, b, c) { return  a.value[5] } } },
      { type: 'bar', color: "#A5978B", label: { show: true, position: "top", color: "#0168c1", formatter: function (a, b, c) { return  a.value[6] } } },
      { type: 'bar', color: "#2b908f", label: { show: true, position: "top", color: "#0168c1", formatter: function (a, b, c) { return  a.value[7] } } },
    ]
  }
}
